// extracted by mini-css-extract-plugin
export default {"button":"MenuInfo_button__x1S8C","overlay":"MenuInfo_overlay__VY3rQ"};